// Extraído de ConsultaCobranca quando a Ficha da instituição precisou dos
// mesmos badges/formatador de valor — segunda ocorrência real, não a
// primeira (mesma régua de outras abstrações desta migração).
export const SITUACAO_COBRANCA_BADGE: Record<string, { label: string; className: string }> = {
  P: { label: "Pago", className: "border-transparent bg-green-100 text-green-800 hover:bg-green-100" },
  A: { label: "Aberto", className: "border-transparent bg-muted text-foreground hover:bg-muted" },
  V: { label: "Vencido", className: "border-transparent bg-red-100 text-red-800 hover:bg-red-100" },
};

// Constantes vindas da integração com Conta Azul (campo metodoPagamento de
// InstituicaoCobranca) — nem todos os valores aparecem na prática pra nós,
// mas o mapa cobre a lista completa retornada pelo Conta Azul.
export const METODO_PAGAMENTO_LABEL: Record<string, string> = {
  DINHEIRO: "Dinheiro",
  CARTAO_CREDITO: "Cartão de crédito",
  BOLETO_BANCARIO: "Boleto bancário",
  CARTAO_CREDITO_VIA_LINK: "Cartão de crédito via link",
  CHEQUE: "Cheque",
  CARTAO_DEBITO: "Cartão de débito",
  TRANSFERENCIA_BANCARIA: "Transferência bancária",
  OUTRO: "Outro",
  CARTEIRA_DIGITAL: "Carteira digital",
  CASHBACK: "Cashback",
  CREDITO_LOJA: "Crédito loja",
  CREDITO_VIRTUAL: "Crédito virtual",
  DEPOSITO_BANCARIO: "Depósito bancário",
  PIX_PAGAMENTO_INSTANTANEO: "Pix",
  PROGRAMA_FIDELIDADE: "Programa de fidelidade",
  SEM_PAGAMENTO: "Sem pagamento",
  VALE_ALIMENTACAO: "Vale alimentação",
  VALE_COMBUSTIVEL: "Vale combustível",
  VALE_PRESENTE: "Vale presente",
  VALE_REFEICAO: "Vale refeição",
  PIX_COBRANCA: "Pix cobrança",
  DEBITO_AUTOMATICO: "Débito automático",
};

export function formatMetodoPagamento(value?: string | null): string {
  if (!value) return "N/D";
  return METODO_PAGAMENTO_LABEL[value] ?? value;
}

// Porte fiel de valorFormatter() — o legado sempre concatena ",90" literal
// em vez de formatar centavos de verdade. Aparenta ser convenção de preço
// (planos fechados em ",90"), não bug — reproduzido como está (ver
// diario.md, entrada de Cobrança).
export function formatValorCobranca(value: number): string {
  return `${value},90`;
}
